import { Navigation, NavigationOff } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * GpsSignalIndicator — estado de señal GPS de un dispositivo/ruta.
 *
 * Tres estados:
 *  - con señal     → <Navigation/>    + tono status-success
 *  - sin señal     → <NavigationOff/> + tono status-warning
 *  - desconocido   → <NavigationOff/> + tono fg-muted   (unknown=true)
 *
 * `unknown` tiene prioridad sobre `hasSignal`. Pensado para reusar en
 * DriverBoard, liveTracking y demás vistas GPS.
 *
 * @param {{
 *   hasSignal: boolean,
 *   unknown?: boolean,
 *   size?: number,               // px del icono lucide (default 14)
 *   label?: string,              // override del texto title/aria-label
 *   t?: (s: string) => string,   // función de i18n opcional (default: identidad)
 *   className?: string,
 * }} props
 */
export function GpsSignalIndicator({
  hasSignal,
  unknown = false,
  size = 14,
  label,
  t,
  className,
}) {
  const tr = typeof t === 'function' ? t : (s) => s;

  let Icon;
  let tone;
  let text;
  if (unknown) {
    Icon = NavigationOff;
    tone = 'text-fg-muted';
    text = label ?? tr('GPS desconocido');
  } else if (hasSignal) {
    Icon = Navigation;
    tone = 'text-status-success';
    text = label ?? tr('GPS en vivo');
  } else {
    Icon = NavigationOff;
    tone = 'text-status-warning';
    text = label ?? tr('Sin señal GPS');
  }

  return (
    <span
      role="img"
      aria-label={text}
      title={text}
      className={cn('inline-flex items-center shrink-0', tone, className)}
    >
      <Icon size={size} aria-hidden />
    </span>
  );
}

export default GpsSignalIndicator;
